import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { YoutubeVideo } from '../../models';
import { YoutubeIframe } from "../../ui-helper"



@Component({
	selector: 'youtube-videos',
	templateUrl: "./youtube-videos.html",
	styles: [require("./youtube-videos.scss")]
})
export class YoutubeVideosComponent {
	public videoControls: {video: YoutubeVideo, control: FormControl}[] = [];

	@Input()
	set videos(vidoes) {
		if (vidoes) {
			this.videoControls = []
			this.addVideos(vidoes);
		}
	}

	@Output() youtubeVideosChange: EventEmitter<YoutubeVideo[]> = new EventEmitter<YoutubeVideo[]>();

	public addVideo(youtubeVideo: YoutubeVideo) {
		if (!youtubeVideo) {
			youtubeVideo = new YoutubeVideo()
		}
		let control: FormControl = new FormControl(youtubeVideo.youTubeUrl);
		this.videoControls.push({video: youtubeVideo, control: control});

		control.valueChanges
		.debounceTime(500)
		.distinctUntilChanged()
		.subscribe((url: string) => youtubeVideo.setVideoUrl(url))
	}

	public removeVideo(listIndex: number) {
		this.videoControls.splice(listIndex, 1);
	}

	public submitVideos() {
		let youtubeVideos: YoutubeVideo[] = []
		this.videoControls.forEach((videoControl) => {
			youtubeVideos.push(videoControl.video)
		})
		this.youtubeVideosChange.emit(youtubeVideos);
	}

	private addVideos(vidoes) {
		vidoes.forEach((video) => {
			this.addVideo(this.loadYouTubeVideo(video))
		})
	}

	private loadYouTubeVideo(video: any): YoutubeVideo {
		let youtubeVideo: YoutubeVideo = new YoutubeVideo()
		youtubeVideo.setVideoUrl(video.youTubeUrl)
		return youtubeVideo
	}
}




// WEBPACK FOOTER //
// ./src/app/ui-helper/youtube-videos/youtube-videos.component.ts